import { render, staticRenderFns } from "./EndScreen.vue?vue&type=template&id=758b1c98&scoped=true&lang=pug&"
import script from "./EndScreen.vue?vue&type=script&lang=js&"
export * from "./EndScreen.vue?vue&type=script&lang=js&"
import style0 from "./EndScreen.vue?vue&type=style&index=0&id=758b1c98&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "758b1c98",
  null
  
)

component.options.__file = "EndScreen.vue"
export default component.exports